const files = require.context('./modules', true, /routes\.(ts|tsx)$/)

const routes = []
files.keys().forEach(key => {
  // routes
  const content = files(key).default
  if (content && Object.keys(files(key).default).length !== 0) {
    routes.push(content)
  }
})
export default routes
